import React, { useEffect, createRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import HashList from '../../utils/hashlist'

import { EDITOR__UPDATE_ACTIVE_POPUP_ID, EDITOR__SHOW_POPUP } from '../../store/actions/editor'

import './PopupSlides.scss'

const Slide = ({ markup, selected = false, style = {}, onClick }) => {
    const { css } = useSelector(state => state.editor.projectTypeData)
    const iframeRef = createRef()
    useEffect(() => {
        if (!iframeRef.current) return
        const iframe = iframeRef.current
        if (!iframe.contentWindow) return
        const document = iframe.contentWindow.document

        document.open()
        document.write(markup + `<link type="text/css" rel="stylesheet" href="${css}" id="id-custom_style">`)
        document.close()
    })

    return (
        <div className={`slide${selected ? ' active' : ''}`} style={style} onClick={onClick}>
            <iframe
                className="slide-view"
                ref={iframeRef}
                style={{ width: '800px', height: '600px', transform: 'scale(0.05)', pointerEvents: 'none' }}
            />
        </div>
    )
}

const PopupSlides = ({}) => {
    const { enablePopups, screens, activeScreenId, activePopupId, showPopup } = useSelector(state => state.editor)
    const dispatch = useDispatch()

    const activeScreen = screens.filter(({ hashlistId }) => hashlistId === activeScreenId)[0]

    const popups = activeScreen ? new HashList(activeScreen.popups).toArray() : []

    useEffect(() => {
        if (window.ScreenManager) {
            if (enablePopups && popups.length) {
                if (window.ScreenManager.showPopupSlides) window.ScreenManager.showPopupSlides()
            } else {
                if (window.ScreenManager.hidePopupSlides) window.ScreenManager.hidePopupSlides()
            }
        }
    }, [enablePopups, popups])

    if (activeScreen === void 0) {
        return null
    }

    return (
        <div className="popup-slides">
            {popups.map(popup => {
                return (
                    <Slide
                        markup={popup.staticMarkup}
                        selected={showPopup && popup.hashlistId === activePopupId}
                        key={popup.hashlistId}
                        onClick={() => {
                            dispatch(EDITOR__UPDATE_ACTIVE_POPUP_ID(popup.hashlistId))
                            dispatch(EDITOR__SHOW_POPUP())
                        }}
                    />
                )
            })}
        </div>
    )
}

export default PopupSlides
